"use client";

import React, { useEffect } from "react";
import { logError } from "@red-digital/bricks";

export const LogPageNotFound = () => {
  useEffect(() => {
    logError("404 page not found");
  }, []);

  return (
    <></>
  );
}
